import {Controller} from "@hotwired/stimulus"
import {useResize} from "stimulus-use"

class ClampVisibilityController extends Controller {
  static targets = ["text", "clampIndicator"]

  connect() {
    useResize(this)
    this.refresh = this.refresh.bind(this)
    this.refresh()
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.refresh)
    }
  }

  resize() {
    this.refresh()
  }

  refresh() {
    this.clampIndicatorTarget.classList.toggle("show", this.is_clamped())
  }

  is_clamped() {
    return this.textTarget.scrollHeight > this.textTarget.clientHeight + 1
  }
}

export default ClampVisibilityController

